import templateUrl from 'webutils/message-icon.htm'

const MessageIconComponent = { 
    bindings : {
        icon: '@',
        size: '@',
        spin: '@',
        type: '@',
        messageClass: '@',
        message: '@'
    },
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
}

export default MessageIconComponent;